/*
 * @Author: mazhigang
 * @Date: 2023-04-23 10:45:21
 * @LastEditors: mazhigang
 * @LastEditTime: 2023-07-06 17:59:01
 */
import Vue from "vue";
import VueRouter from "vue-router";
const r = require.context("../view", true, /.vue/);
const routeArr = [
  {
    name: "/",
    path: "/",
    redirect: "/index"
  }
];
r.keys().forEach(key => {
  const keyArr = key.split(".");
  // if (key.indexOf("index") > -1) {
  //   // 约定式路由构成方案，view文件夹下的index.vue文件都会自动化生成路由
  // }
  const pathArr = keyArr[1].split("/");
  routeArr.push({
    name: pathArr[2],
    path: "/" + pathArr[2],
    component: r(key).default // 这是组件
  });
});
Vue.use(VueRouter);
const router = new VueRouter({
  mode: "history",
  // mode: "hash",
  base: process.env.BASE_URL,
  routes: routeArr
});
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};
export default router;
